import { Component, OnInit } from '@angular/core';
import { HaHeaderServiceService } from '../../services/HaHeader.service';
import { Location } from '@angular/common';
import { HaProfileInfo } from '../ha-models/ha-profile-info';
import { NgForm } from '@angular/forms';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';
import { SchedulerEventModel } from '../../models/SchedulerEventModel';
import { DatePipe } from '@angular/common'
import { ConflictedRecordModel } from '../../models/ConflictedRecordModel.model';

@Component({
  selector: 'app-ha-dashboard-component',
  templateUrl: './ha-dashboard-component.component.html',
  styleUrls: ['./ha-dashboard-component.component.css']
})

export class HaDashboardComponentComponent implements OnInit {
  displayProfile: boolean = true;
  element: HTMLElement;
  docEvents: SchedulerEventModel[];
  DataClassOne: SchedulerEventModel[];
  profileInfo: HaProfileInfo;
  updateInfo: HaProfileInfo;
  showPercentage: boolean = false;
  loadingPercentage: number;
  totalCount: any[];
  userList: any[];
  dashData: any[];
  mydashData: any;

  conflictedRecord: ConflictedRecordModel[];

  currentDate;
  showOverlayDashboard: boolean;
  smallLoader: boolean = false;
  mainViewError = new ErrorModel();
  profileError = new ErrorModel();
  datepipe: any;
  constructor(private service: HaHeaderServiceService, private _route: Router) { }

  ngOnInit() {
    this.showOverlayDashboard = true;
    this.getProfileInfo();
    this.getDashboardData();
    this.getConfData();
  }

  getConfData(){
    this.service.getConflictedPatient().subscribe(
      (data: any[]) => {
        console.log("Conflicted record loaded succesfully")
        this.conflictedRecord = data;
      },
      (error) => {
        //this.getPatientList(1, '', '');
        console.log("Failed to load Conflicted record");
        AlertMessages.Show('Failed', 'Could not load all data!', AlertType.Error);
    
      }).add(() => {
       // this.showPatientListLoad = false;
    
      });
  }
  getDashboardData() {
    this.mydashData = { "todayScheduled": "Loading..." };
    this.service.getTodaySchedule().subscribe(
      (data: any[]) => {
        
          this.docEvents = data;
          var count = 0;
          var todayDate = new Date();
          // this.DataClassOne.pop();
          for (let i = 0; i < data.length; i++) {
              this.docEvents[i].fromTime = new Date(this.docEvents[i].start);
              this.docEvents[i].toTime = new Date(this.docEvents[i].end);
              console.log(i + "serverTime->" + this.docEvents[i].fromTime.toLocaleDateString() + "  TodayDate-> " + todayDate.toLocaleDateString());
              if (this.docEvents[i].fromTime.toLocaleDateString() == todayDate.toLocaleDateString()) {
                  count++;
              }
              
              // this.DataClassOne.push(this.docEvents[i]);
          }
          this.mydashData = { "todayScheduled": count };
          
      },
      (error) => {
          this.mydashData = { "todayScheduled": 0 };
      }).add(() => {
          
      });
    this.showOverlayDashboard = true;
    this.mainViewError.display = false;
    this.service.getDashboardData().subscribe(
        (data: any[]) => {
            
      this.dashData = data;
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
      AlertMessages.Show('Failed', 'Could not load!', AlertType.Error);
    }).add(() => {
      this.showOverlayDashboard = false;
    });
  }

  getProfileInfo() {
    this.profileError.display = false;
    this.smallLoader = true;
    this.service.getProfileData().subscribe(
    (data: HaProfileInfo) => {
      this.profileInfo = data;
    },
    (error) => {
      this.profileError.error = error;
      this.profileError.display = true;
    }).add(() => {
      this.smallLoader = false;
    });
  }

  onClickEdit() {
    this.displayProfile = false;
  }

  uploadPhoto(evt) {
    let File = evt.target.files;
    let photo = File[0];
    if (photo.name.search(/.jpg|.jpeg|.png|.tiff|.bmp /g) == -1) {
      alert('Please add an Image file ( jpg,jpeg,png,tiff,bmp )');
    }  else if (File[0].size > 2000000) {
      alert(' Select an image of size upto 2 MB');
    } else {
    this.showPercentage = true;
      this.service.uploadAdminPhoto(photo).subscribe(event => {
        if (event.type == HttpEventType.UploadProgress) {
          this.loadingPercentage = Math.round(event.loaded / event.total * 100);
        } else if (event.type == HttpEventType.Response) {
          let reader = new FileReader();
          reader.onload = (abc: any) => {
            this.profileInfo.photoUrl = abc.target.result;
            document.getElementById('userImg').setAttribute('src', abc.target.result);
          }
          reader.readAsDataURL(photo);
          this.showPercentage = false;
        }
      }, (error: HttpErrorResponse) => { this.showPercentage = false; alert(error.statusText); });
    }
  }

  onProfileSubmit(Form: NgForm) {
    this.updateInfo = Form.value as HaProfileInfo;
    this.service.updateProfileInfo(this.updateInfo).subscribe(
    (data) => {
      this.displayProfile = true;
      document.getElementById("userNamee").innerHTML = this.updateInfo.name;
      if (data != null) {
      AlertMessages.Show("Profile Updation", data["StatusMessage"], AlertType.Success);
        this.profileInfo.name = this.updateInfo.name;
        this.profileInfo.hospitalAddress = this.updateInfo.hospitalAddress;
        this.profileInfo.hospitalName = this.updateInfo.hospitalName;
        this.profileInfo.hospitalRegistrationId = this.updateInfo.hospitalRegistrationId;
      }
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not update!', AlertType.Error);
    });
  }

  deleteRow(i){
    var item =this.conflictedRecord[i];
    item.Status = 0;
    this.conflictedRecord[i]=item;
    console.log("delete row " + i)
  }

  mergeRow(i){
    var item =this.conflictedRecord[i];
    item.Status = 2;
    this.conflictedRecord[i]=item;
    console.log("Merge row " + i)
  }

  newRow(i){
    var item =this.conflictedRecord[i];
    item.Status = 1;
    this.conflictedRecord[i]=item;
    console.log("New row inserted " + i)
  }

  saveConflictedData(){
    if(this.conflictedRecord.length>0){
    this.showOverlayDashboard = true;
    this.service.saveConflictedPatient(this.conflictedRecord).subscribe(
      (data: any[]) => {
        this.showOverlayDashboard = false;
        console.log("Confliction Resolved succesfully")
        location.reload(); 
        //this.conflictedRecord = data;
        
      },
      (error) => {
        this.showOverlayDashboard = false;
        //this.getPatientList(1, '', '');
        console.log("Failed to Resolve Confliction ");
       // AlertMessages.Show('Failed', 'Could not load all data!', AlertType.Error);
    
      }).add(() => {
       // this.showPatientListLoad = false;
    
      });

    }
  }

  routeToUser(index) {
    if (index == 'User') {
      this._route.navigate(['Hospital/HAAdmin/UserManagement'], {});
    } else if (index == 'Pat') {
      this._route.navigate(['Hospital/HAAdmin/PatientLists'], {});
    } else if (index == 'Case') {
      this._route.navigate(['Hospital/HAAdmin/CaseLists'], {});
    } else if (index == 'Temp') {
      this._route.navigate(['Hospital/HAAdmin/TemplateSharing'], {});
    } else if (index == 'Sch') {
      this._route.navigate(['Hospital/HAAdmin/ScheduledPatient'], {});
    }
  }

}
